import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { LOCALE_CODE } from 'app/constants/language';
import { selectLocalization } from 'app/selectors/LocalizationSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

const useLocaleCodes = () => {
  const currentLibrary = useSelector(selectCurrentLibrary);
  const localization = useSelector(selectLocalization);
  const { availableLanguages: localeCodes = [] } = localization;

  const [availableLocaleCodes, setAvailableLocaleCodes] = useState([]);

  useEffect(() => {
    setAvailableLocaleCodes(
      localeCodes.filter(localeCode => {
        return localeCode !== LOCALE_CODE.JAPANESE_JAPAN_NON_STANDARD;
      })
    );
  }, [localeCodes]);

  const isAvailableLocaleCode = localeCode => {
    return localeCodes.includes(localeCode);
  };

  const defaultLocaleCode = currentLibrary.get('defaultLanguage') ?? localeCodes[0];

  const intl = useIntl();
  const mapLocaleCodeToLabel = useCallback(
    localeCode => {
      if (!localeCode) {
        return '';
      }

      const id = `Languages.${localeCode.replace('-', '')}`;
      return intl.formatMessage({ id });
    },
    [intl]
  );

  return {
    availableLocaleCodes,
    defaultLocaleCode,
    isAvailableLocaleCode,
    mapLocaleCodeToLabel
  };
};

export default useLocaleCodes;
